import SizeBox from 'components/common/SizeBox';
import {
  FORM_INPUT_UPLOAD_DOCUMENTS_FILE_TAKE_PHOTO_TYPE_SELECT_FILE,
  VERIFICATION_UPLOAD_DOCUMENTS_DRIVER_LICENCE_BACK_FIELD,
  VERIFICATION_UPLOAD_DOCUMENTS_DRIVER_LICENCE_BACK_NAME,
  VERIFICATION_UPLOAD_DOCUMENTS_DRIVER_LICENCE_FRONT_FIELD,
  VERIFICATION_UPLOAD_DOCUMENTS_DRIVER_LICENCE_FRONT_NAME,
  VERIFICATION_UPLOAD_DOCUMENTS_PASSPORT_FIELD,
  VERIFICATION_UPLOAD_DOCUMENTS_PASSPORT_NAME,
  VERIFICATION_UPLOAD_DOCUMENTS_SELECT_DRIVER_LICENCE_SWITCH_NAME,
} from 'constants';
import FormInputUploadDocumentsFileTakePhotoValidation from 'features/uploadDocuments/components/VerificationUploadDocumentsDetails/components/FormInputUploadDocumentsFileTakePhotoValidation';
import FormInputUploadDocumentsSelectIdTypeSwitch from 'features/uploadDocuments/components/VerificationUploadDocumentsDetails/components/FormInputUploadDocumentsSelectIdTypeSwitch';
import useFormInput from 'hooks/form/useFormInput';
import useLang from 'hooks/useLang';
import React from 'react';
import styled from 'styled-components';
import { displayFlexRowCenterStartMixin, paragraph500Mixin } from 'styles';

const FormEditPersonalDetailsUploadDocuments = ({
  information,
  setInformation,
  validation,
  setValidation,
}) => {
  const { t } = useLang();

  const isDriverLicenceSelected =
    information[
      VERIFICATION_UPLOAD_DOCUMENTS_SELECT_DRIVER_LICENCE_SWITCH_NAME
    ];

  const renderVerificationUploadDocumentsDriverLicence = () => {
    return (
      <>
        <UploadDocumentsForm>
          <FormInputUploadDocumentsFileTakePhotoValidation
            field={VERIFICATION_UPLOAD_DOCUMENTS_DRIVER_LICENCE_FRONT_FIELD}
            information={information}
            setInformation={setInformation}
            validation={validation}
            setValidation={setValidation}
            fileTakePhotoType={
              FORM_INPUT_UPLOAD_DOCUMENTS_FILE_TAKE_PHOTO_TYPE_SELECT_FILE
            }
          />
          <FormInputUploadDocumentsFileTakePhotoValidation
            field={VERIFICATION_UPLOAD_DOCUMENTS_DRIVER_LICENCE_BACK_FIELD}
            information={information}
            setInformation={setInformation}
            validation={validation}
            setValidation={setValidation}
            fileTakePhotoType={
              FORM_INPUT_UPLOAD_DOCUMENTS_FILE_TAKE_PHOTO_TYPE_SELECT_FILE
            }
          />
        </UploadDocumentsForm>
      </>
    );
  };
  const renderVerificationUploadDocumentsPassport = () => {
    return (
      <UploadDocumentsForm>
        <FormInputUploadDocumentsFileTakePhotoValidation
          field={VERIFICATION_UPLOAD_DOCUMENTS_PASSPORT_FIELD}
          information={information}
          setInformation={setInformation}
          validation={validation}
          setValidation={setValidation}
          fileTakePhotoType={
            FORM_INPUT_UPLOAD_DOCUMENTS_FILE_TAKE_PHOTO_TYPE_SELECT_FILE
          }
        />
      </UploadDocumentsForm>
    );
  };
  const renderVerificationUploadDocuments = () => {
    if (isDriverLicenceSelected)
      return <>{renderVerificationUploadDocumentsDriverLicence()}</>;
    return <>{renderVerificationUploadDocumentsPassport()}</>;
  };

  const renderFormControlFeedback = () => {
    if (isDriverLicenceSelected)
      return (
        <>
          <FormControlFeedback
            value={
              isDriverLicenceSelected
                ? t(
                    validation[
                      VERIFICATION_UPLOAD_DOCUMENTS_DRIVER_LICENCE_FRONT_NAME
                    ] ||
                      validation[
                        VERIFICATION_UPLOAD_DOCUMENTS_DRIVER_LICENCE_BACK_NAME
                      ]
                  )
                : validation[VERIFICATION_UPLOAD_DOCUMENTS_PASSPORT_NAME]
            }
            validationStyles={{ position: 'unset' }}
          />
        </>
      );
    return (
      <FormControlFeedback
        value={t(validation[VERIFICATION_UPLOAD_DOCUMENTS_PASSPORT_NAME])}
        validationStyles={{ position: 'unset' }}
      />
    );
  };
  const { FormControlFeedback } = useFormInput();
  const renderVerificationUploadDocumentsTypesBodyContent = () => {
    return (
      <>
        <Title
          $isRequired={
            isDriverLicenceSelected
              ? validation[
                  VERIFICATION_UPLOAD_DOCUMENTS_DRIVER_LICENCE_FRONT_NAME
                ] ||
                validation[
                  VERIFICATION_UPLOAD_DOCUMENTS_DRIVER_LICENCE_BACK_NAME
                ]
              : validation[VERIFICATION_UPLOAD_DOCUMENTS_PASSPORT_NAME]
          }
        >
          {t(
            'label_profile_kyc_personal_details_upload_documents_select_id_type'
          )}
        </Title>
        <SizeBox height={10} />
        <FormInputUploadDocumentsSelectIdTypeSwitch
          information={information}
          setInformation={setInformation}
          validation={validation}
          setValidation={setValidation}
        />
        <SizeBox height={16} />
        {renderVerificationUploadDocuments()}
        {renderFormControlFeedback()}
      </>
    );
  };

  return (
    <FormEditPersonalDetailsUploadDocumentsStyled>
      {renderVerificationUploadDocumentsTypesBodyContent()}
    </FormEditPersonalDetailsUploadDocumentsStyled>
  );
};

const FormEditPersonalDetailsUploadDocumentsStyled = styled.div`
  height: fit-content;
  width: 100%;
`;

const Title = styled.p`
  ${paragraph500Mixin};
  ${(props) =>
    props.$isRequired &&
    `
    color: var(--ds-c-red);
  `}
`;

const UploadDocumentsForm = styled.div`
  ${displayFlexRowCenterStartMixin};
  gap: 10px;
`;

export default FormEditPersonalDetailsUploadDocuments;
